import Image from 'next/image';
import * as React from 'react';

const SanityLogo = () => {
    return (
        <Image
            unoptimized={true}
            src="/images/logo/logo_p_only.png"
            alt="Sanity"
            width={25}
            height={25}
            title="Click me to reload this page."
        />
    );
};

export default SanityLogo;
